import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from 'primereact/panel';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {InputSwitch} from 'primereact/inputswitch';
import {BlockUI} from 'primereact/blockui';
import {Badge} from 'primereact/badge';
import {Password} from 'primereact/password';
import {Dropdown} from 'primereact/dropdown';
import axios from 'axios';
import Cookies from 'js-cookie';

import HelpComponent from '../HelpComponent';

const PaycenterFormComponent = (props) => {
  const {t} = props;
  const [loading, setLoading] = useState(true);
  const [paycenter, setPaycenter] = useState({});
  const [paycenterConnect, setPaycenterConnect] = useState({
    selectedPaycenterRegistrationId: null,
    paycenterEmail: '',
    paycenterPassword: ''
  });
  const [paycenterRegistrations, setPaycenterRegistrations] = useState([]);
  const [paycenterLoginSelectLoaded, setPaycenterLoginSelectLoaded] = useState(false);
  const [quickSetup, setQuickSetup] = useState({
    selected_accepting_place_id: null,
    accepting_place_name: '',
    company_name: '',
    tax_number: '',
    zip_code: '',
    registered_office_city: '',
    street_and_house_number: '',
    vat_payment: true
  });
  const [acceptingPlaces, setAcceptingPlaces] = useState([]);
  const [acceptingPlacesLoading, setAcceptingPlacesLoading] = useState(false);
  const [acceptingPlacesLoaded, setAcceptingPlacesLoaded] = useState(false);
  const [quickSetupDone, setQuickSetupDone] = useState(false);
  const [showQuickSetupForm, setShowQuickSetupForm] = useState(false);
  const quickSetupVisible = (paycenter.status === 'connected' && paycenter.payment_ready !== true) || showQuickSetupForm === true;

  useEffect(() => {
    setLoading(true);
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'integration/paycenter',
      params: {},
      headers: {
        Authorization: 'Bearer ' + Cookies.get('userToken'),
        'Sys-name': Cookies.get('instanceId'),
        'Preferred-locale': Cookies.get('language')
      }
    })
      .then((response) => {
        setPaycenter(response.data.data || {});
        const selectedAcceptingPlaceId = response.data.data?.selected_accepting_place?.id
          || response.data.data?.selectedAcceptingPlace?.id
          || response.data.data?.operator_data?.selected_accepting_place?.id
          || response.data.data?.operator_data?.selectedAcceptingPlace?.id
          || null;
        setQuickSetup({
          selected_accepting_place_id: selectedAcceptingPlaceId,
          accepting_place_name: response.data.data?.accepting_place_name || response.data.data?.acceptingPlaceName || response.data.data?.operator_data?.accepting_place_name || response.data.data?.operator_data?.acceptingPlaceName || '',
          company_name: response.data.data?.company_name || response.data.data?.companyName || response.data.data?.operator_data?.company_name || response.data.data?.operator_data?.companyName || '',
          tax_number: response.data.data?.tax_number || response.data.data?.taxNumber || response.data.data?.operator_data?.tax_number || response.data.data?.operator_data?.taxNumber || '',
          zip_code: response.data.data?.zip_code || response.data.data?.zipCode || response.data.data?.operator_data?.zip_code || response.data.data?.operator_data?.zipCode || '',
          registered_office_city: response.data.data?.registered_office_city || response.data.data?.registeredOfficeCity || response.data.data?.operator_data?.registered_office_city || response.data.data?.operator_data?.registeredOfficeCity || '',
          street_and_house_number: response.data.data?.street_and_house_number || response.data.data?.streetAndHouseNumber || response.data.data?.operator_data?.street_and_house_number || response.data.data?.operator_data?.streetAndHouseNumber || '',
          vat_payment: response.data.data?.vat_payment ?? response.data.data?.vatPayment ?? response.data.data?.operator_data?.vat_payment ?? response.data.data?.operator_data?.vatPayment ?? true
        });
        setQuickSetupDone(response.data.data?.status === 'payment_ready' || response.data.data?.payment_ready === true);
        setShowQuickSetupForm(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [window.App.state.rerenderPaycenterForm]);

  useEffect(() => {
    if (!quickSetupVisible || acceptingPlacesLoaded || acceptingPlacesLoading) {
      return;
    }

    setAcceptingPlacesLoading(true);
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'integration/paycenter/accepting-places',
      params: {},
      headers: {
        Authorization: 'Bearer ' + Cookies.get('userToken'),
        'Sys-name': Cookies.get('instanceId'),
        'Preferred-locale': Cookies.get('language')
      }
    })
      .then((response) => {
        const options = (response?.data?.data?.accepting_places || [])
          .map((item) => {
            const id = item?.id;
            const label = item?.name
              || (id ? `#${id}` : '');
            return id ? {id, label} : null;
          })
          .filter(Boolean);

        setAcceptingPlaces(options);
        setAcceptingPlacesLoaded(true);
      })
      .catch((error) => {
        setAcceptingPlacesLoaded(true);
        window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
      })
      .finally(() => {
        setAcceptingPlacesLoading(false);
      });
  }, [quickSetupVisible, acceptingPlacesLoaded, acceptingPlacesLoading, t]);

  const getPaycenterApiErrorMessage = (error) => {
    const responseData = error?.response?.data || {};
    const nestedData = responseData?.data || {};
    const technicalCode = responseData?.error_code
      || responseData?.errorCode
      || responseData?.technical_code
      || responseData?.technicalCode
      || responseData?.code
      || nestedData?.error_code
      || nestedData?.errorCode
      || nestedData?.technical_code
      || nestedData?.technicalCode
      || nestedData?.code;
    const message = responseData?.message || responseData?.error || error.toString();

    if (technicalCode && !String(message).includes(String(technicalCode))) {
      return `${message} ${technicalCode}`;
    }

    return message;
  };
  const paycenterStatusErrorText = t('paycenter_status_error');
  const paycenterLastErrorText = paycenter.last_error ? String(paycenter.last_error).trim() : '';
  const paycenterErrorMessage = paycenterLastErrorText
    ? (paycenterLastErrorText.startsWith(paycenterStatusErrorText)
      ? paycenterLastErrorText
      : `${paycenterStatusErrorText} ${paycenterLastErrorText}`)
    : paycenterStatusErrorText;
  const paycenterReadySuccessMessage = 'A Paycenter készen áll. Az újonnan szinkronizált számlák automatikusan payment linket küldenek.';
  const hasSelectedAcceptingPlace = !!quickSetup.selected_accepting_place_id;
  const hasNewAcceptingPlaceName = !!quickSetup.accepting_place_name?.trim();
  const hasRequiredQuickSetupData = quickSetup.company_name
    && quickSetup.tax_number
    && quickSetup.zip_code
    && quickSetup.registered_office_city
    && quickSetup.street_and_house_number;
  const isNewAcceptingPlaceMode = !hasSelectedAcceptingPlace;
  const isQuickSetupValid = () => hasSelectedAcceptingPlace || (hasNewAcceptingPlaceName && hasRequiredQuickSetupData);
  const getQuickSetupFirstInvalidFieldId = () => {
    if (hasSelectedAcceptingPlace) {
      return null;
    }

    if (!hasNewAcceptingPlaceName) {
      return 'paycenter_quick_setup_accepting_place_name';
    }

    if (!quickSetup.company_name) {
      return 'paycenter_quick_setup_company_name';
    }

    if (!quickSetup.tax_number) {
      return 'paycenter_quick_setup_tax_number';
    }

    if (!quickSetup.zip_code) {
      return 'paycenter_quick_setup_zip_code';
    }

    if (!quickSetup.registered_office_city) {
      return 'paycenter_quick_setup_registered_office_city';
    }

    if (!quickSetup.street_and_house_number) {
      return 'paycenter_quick_setup_street_and_house_number';
    }

    return 'paycenter_quick_setup_selected_accepting_place';
  };
  const getQuickSetupPayload = () => {
    if (hasSelectedAcceptingPlace) {
      return {
        selected_accepting_place: {
          id: quickSetup.selected_accepting_place_id
        }
      };
    }

    return {
      accepting_place_name: quickSetup.accepting_place_name?.trim(),
      company_name: quickSetup.company_name,
      tax_number: quickSetup.tax_number,
      zip_code: quickSetup.zip_code,
      registered_office_city: quickSetup.registered_office_city,
      street_and_house_number: quickSetup.street_and_house_number,
      vat_payment: quickSetup.vat_payment
    };
  };
  const getPaycenterConnectPayload = () => ({
    selected_paycenter_registration: {
      id: paycenterConnect.selectedPaycenterRegistrationId
    },
    paycenter_email: paycenterConnect.paycenterEmail,
    paycenter_password: paycenterConnect.paycenterPassword
  });
  const handleConnect = () => {
    if (!paycenterConnect.selectedPaycenterRegistrationId || !paycenterConnect.paycenterEmail || !paycenterConnect.paycenterPassword) {
      window.App.toastShow('warn', t('warning'), t('paycenter_connect_required_fields'));
      return;
    }

    setLoading(true);
    axios.post(
      process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'integration/paycenter/link',
      getPaycenterConnectPayload(),
      {
        params: {},
        headers: {
          Authorization: 'Bearer ' + Cookies.get('userToken'),
          'Sys-name': Cookies.get('instanceId'),
          'Preferred-locale': Cookies.get('language')
        }
      }
    )
      .then((response) => {
        setLoading(false);
        window.App.toastShow('success', t('success'), response.data.message);
        window.App.setState({
          rerenderPaycenterForm: Math.random()
        });
      })
      .catch((error) => {
        const paycenterApiErrorMessage = getPaycenterApiErrorMessage(error);
        setLoading(false);
        setPaycenter((prev) => ({
          ...prev,
          status: 'link_error',
          last_error: paycenterApiErrorMessage
        }));
        window.App.toastShow('error', t('error'), paycenterApiErrorMessage, '', error.response);
      });
  };
  const handleRetryLink = () => {
    if (!paycenterConnect.selectedPaycenterRegistrationId || !paycenterConnect.paycenterEmail || !paycenterConnect.paycenterPassword) {
      window.App.toastShow('warn', t('warning'), t('paycenter_connect_required_fields'));
      return;
    }

    setLoading(true);
    axios.post(
      process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'integration/paycenter/link/retry',
      getPaycenterConnectPayload(),
      {
        params: {},
        headers: {
          Authorization: 'Bearer ' + Cookies.get('userToken'),
          'Sys-name': Cookies.get('instanceId'),
          'Preferred-locale': Cookies.get('language')
        }
      }
    )
      .then((response) => {
        setLoading(false);
        window.App.toastShow('success', t('success'), response.data.message);
        window.App.setState({
          rerenderPaycenterForm: Math.random()
        });
      })
      .catch((error) => {
        const paycenterApiErrorMessage = getPaycenterApiErrorMessage(error);
        setLoading(false);
        setPaycenter((prev) => ({
          ...prev,
          status: 'link_error',
          last_error: paycenterApiErrorMessage
        }));
        window.App.toastShow('error', t('error'), paycenterApiErrorMessage, '', error.response);
      });
  };
  const handleDisconnect = () => {
    setLoading(true);
    axios.delete(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'integration/paycenter/link', {
      params: {},
      headers: {
        Authorization: 'Bearer ' + Cookies.get('userToken'),
        'Sys-name': Cookies.get('instanceId'),
        'Preferred-locale': Cookies.get('language')
      }
    })
      .then((response) => {
        setQuickSetupDone(false);
        setLoading(false);
        window.App.toastShow('success', t('success'), response.data.message);
        window.App.setState({
          rerenderPaycenterForm: Math.random()
        });
      })
      .catch((error) => {
        setLoading(false);
        window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
      });
  };

  return (
    <>
      <BlockUI blocked={loading} className="blocked-ui-overlay">
        <Panel className={'p-mt-3'}>
          <div className={'p-grid'}>
            <div className={'p-col-12 p-lg-5 p-col-align-center'}>
              <h2 className={'p-m-0'}>
                {t('paycenter_integration')}
              </h2>
              <Badge
                value={t(paycenter.status || 'not_connected')}
                style={{
                  position: 'relative',
                  top: '-3px'
                }}
              />
            </div>
            <div className={'p-col-12 p-lg-7 p-text-right p-col-align-center'}>
              {(paycenter.status === 'not_connected' || paycenter.status === 'disconnected' || paycenter.status === 'paycenter_registration_error') && showQuickSetupForm !== true &&
                <Button
                  type="button"
                  label={t('paycenter_connect')}
                  icon={'pi pi-link'}
                  loading={loading}
                  onClick={handleConnect}
                  className="p-button-success"
                />
              }
              {paycenter.status === 'link_error' &&
                <Button
                  type="button"
                  label={t('retry')}
                  icon={'pi pi-sync'}
                  loading={loading}
                  onClick={handleRetryLink}
                  className="p-button-warning"
                />
              }
              {((paycenter.status === 'connected' && paycenter.payment_ready !== true) || paycenter.status === 'payment_ready') &&
                <Button
                  type="button"
                  label={t('disconnect')}
                  icon={'pi pi-times'}
                  loading={loading}
                  onClick={handleDisconnect}
                  className="p-button-danger"
                />
              }
              {(paycenter.status === 'connected' && paycenter.payment_ready !== true) &&
                <Button
                  type="button"
                  label={t('paycenter_complete_setup')}
                  icon={'pi pi-save'}
                  className="p-button-success p-ml-2"
                  loading={loading}
                  onClick={() => {
                    if (!isQuickSetupValid()) {
                      window.App.toastShow('warn', t('warning'), t('paycenter_quick_setup_required_fields'));
                      const invalidFieldId = getQuickSetupFirstInvalidFieldId();
                      if (invalidFieldId) {
                        document.getElementById(invalidFieldId)?.focus();
                      }
                      return;
                    }
                    setLoading(true);
                    axios.post(
                      process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'integration/paycenter/quick-setup',
                      getQuickSetupPayload(),
                      {
                        params: {},
                        headers: {
                          Authorization: 'Bearer ' + Cookies.get('userToken'),
                          'Sys-name': Cookies.get('instanceId'),
                          'Preferred-locale': Cookies.get('language')
                        }
                      }
                    )
                      .then((response) => {
                        setQuickSetupDone(true);
                        setShowQuickSetupForm(false);
                        setLoading(false);
                        window.App.toastShow('success', t('success'), response.data.message || t('paycenter_quick_setup_success'));
                        window.App.setState({
                          rerenderPaycenterForm: Math.random()
                        });
                      })
                      .catch((error) => {
                        setLoading(false);
                        window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
                      });
                  }}
                />}
              <Button type="button"
                      icon={"pi pi-times"}
                      onClick={() => {
                        window.App.setState({sidebarPaycenterForm: false});
                      }}
                      className="p-button-secondary close p-ml-2">
              </Button>
            </div>
          </div>

          {/*<HelpComponent type={'edit_box'}/>*/}

          {(paycenter.status === 'connected' && paycenter.payment_ready !== true) &&
            <div className={'p-mb-3'}>
              <HelpComponent type={'custom_message'} level={'LEVEL_WARNING'}
                             message={t('paycenter_status_connected_needs_setup')}/>
              <HelpComponent type={'custom_message'} level={'LEVEL_WARNING'}
                             message={t('paycenter_status_connected_needs_setup_help')}/>
            </div>}

          {(paycenter.status === 'payment_ready' && paycenter.payment_ready === true) &&
            <>
              <div className={'p-mb-3'}>
                <HelpComponent
                  type={'custom_message'}
                  level={'LEVEL_SUCCESS'}
                  message={paycenterReadySuccessMessage}
                />
              </div>
              <div className={'p-grid'}>
                <div className={"p-col-12 p-lg-6"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="paycenter_email">{t('paycenter_email')}</label>
                    <span className="p-d-block fake-input">
                        {paycenter.paycenter_email || '***'}
                      </span>
                  </div>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <Button
                    type="button"
                    label={'Paycenter online fizetés'}
                    icon={'pi pi-window-maximize'}
                    className="p-button p-button-info p-mt-3 p-d-block w-100"
                    onClick={() => {
                      window.open(process.env.REACT_APP_PAYCENTER_LOGIN_URL, '_blank', 'noopener,noreferrer');
                    }}
                  />
                </div>
              </div>
            </>
          }

          {(quickSetupDone === true && paycenter.status !== 'not_connected' && paycenter.status !== 'disconnected' && !(paycenter.status === 'payment_ready' && paycenter.payment_ready === true)) &&
            <div className={'p-mb-3 p-p-3'}
                 style={{border: '1px solid #10b981', borderRadius: '6px', background: '#ecfdf5'}}>
              <div className={'p-text-bold'}>{t('paycenter_quick_setup_success')}</div>
            </div>}

          {(paycenter.status === 'link_error' || paycenter.status === 'paycenter_registration_error') &&
            <div className={'p-mb-3'}>
              <HelpComponent type={'custom_message'} level={'LEVEL_DANGER'} message={paycenterErrorMessage}/>
            </div>}
          {(paycenter.status === 'not_connected' || paycenter.status === 'disconnected') &&
            <div className={'p-mb-3'}>
              <HelpComponent type={'custom_message'} level={'LEVEL_WARNING'}
                             message={t('paycenter_status_not_connected')}/>
            </div>}

          {(paycenter.status === 'not_connected' || paycenter.status === 'disconnected' || paycenter.status === 'link_error' || paycenter.status === 'paycenter_registration_error') && showQuickSetupForm !== true &&
            <>
              <h3 className={'p-my-3'}>{t('paycenter_connect')}</h3>
              <div className={'p-grid'}>
                <div className={'p-col-12 p-lg-4'}>
                  <div className="p-field p-fluid">
                    <HelpComponent type={'field'} field={'paycenter_email'}/>
                    <label htmlFor="paycenter_email">{t('paycenter_email')}</label>
                    <span className="p-d-block">
                      <InputText
                        id="paycenter_email"
                        onChange={(e) => {
                          setPaycenterConnect({
                            ...paycenterConnect,
                            paycenterEmail: e.target.value,
                            selectedPaycenterRegistrationId: null
                          });
                          setPaycenterRegistrations([]);
                          setPaycenterLoginSelectLoaded(false);
                        }}
                        onBlur={(e) => {
                          const value = e.target.value || '';

                          if (value.includes('@') && value.includes('.')) {
                            axios.post(
                              process.env.REACT_APP_PAYCENTER_LOGIN_SELECT_URL,
                              {email: value},
                              {
                                params: {},
                                headers: {
                                  'Preferred-locale': Cookies.get('language')
                                }
                              }
                            )
                              .then((response) => {
                                const registrations = (response?.data?.data?.items || [])
                                  .map((item) => {
                                    const id = item?.id ?? item?.instance_id ?? item?.instanceId;
                                    const label = item?.system_name
                                      || item?.systemName
                                      || item?.instance_name
                                      || item?.instanceName
                                      || item?.name
                                      || item?.system_name_slugged
                                      || (id ? `#${id}` : '');
                                    return id === null || id === undefined || !label ? null : {id, label};
                                  })
                                  .filter(Boolean);
                                setPaycenterRegistrations(registrations);
                                setPaycenterLoginSelectLoaded(true);
                                if (registrations.length === 0) {
                                  window.App.toastShow('warn', t('warning'), t('paycenter_login_select_empty'));
                                }
                              })
                              .catch((error) => {
                                setPaycenterRegistrations([]);
                                setPaycenterConnect((prev) => ({
                                  ...prev,
                                  selectedPaycenterRegistrationId: null
                                }));
                                setPaycenterLoginSelectLoaded(false);
                                window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
                              });
                          } else {
                            setPaycenterRegistrations([]);
                            setPaycenterConnect((prev) => ({
                              ...prev,
                              selectedPaycenterRegistrationId: null
                            }));
                            setPaycenterLoginSelectLoaded(false);
                          }
                        }}
                        value={paycenterConnect.paycenterEmail}
                      />
                    </span>
                  </div>
                </div>
                <div className={'p-col-12 p-lg-4'}>
                  <div className="p-field p-fluid">
                    <label htmlFor="paycenter_registration_instance">{t('paycenter_account')}</label>
                    <span className="p-d-block">
                      <Dropdown 
                        id="paycenter_registration_instance"
                        options={paycenterRegistrations}
                        optionLabel="label"
                        optionValue="id"
                        value={paycenterConnect.selectedPaycenterRegistrationId}
                        onChange={(e) => {
                          setPaycenterConnect({
                            ...paycenterConnect,
                            selectedPaycenterRegistrationId: e.value
                          });
                        }}
                        placeholder={t('paycenter_account')}
                        emptyMessage={t('empty_message')}
                        disabled={!paycenterLoginSelectLoaded}
                      />
                    </span>
                  </div>
                </div>
                <div className={'p-col-12 p-lg-4'}>
                  <div className="p-field p-fluid">
                    <HelpComponent type={'field'} field={'paycenter_password'}/>
                    <label htmlFor="paycenter_password">{t('paycenter_password')}</label>
                    <span className="p-d-block">
                      <Password
                        id="paycenter_password"
                        onChange={(e) => {
                          setPaycenterConnect({
                            ...paycenterConnect,
                            paycenterPassword: e.target.value
                          });
                        }}
                        value={paycenterConnect.paycenterPassword}
                        disabled={!paycenterLoginSelectLoaded}
                        toggleMask
                        feedback={false}
                      />
                    </span>
                  </div>
                </div>
              </div>
              {process.env.REACT_APP_PAYCENTER_REGISTER_URL && paycenter.status !== 'link_error' &&
                <div className={'p-grid'}>
                  <div className={'p-col-12 p-text-left'}>
                    <Button
                      type="button"
                      label={'Paycenter fiók létrehozása'}
                      icon={'pi pi-window-maximize'}
                      className="p-button p-button-info"
                      onClick={() => {
                        window.open(process.env.REACT_APP_PAYCENTER_REGISTER_URL, '_blank', 'noopener,noreferrer');
                      }}
                    />
                  </div>
                </div>}
            </>}

          {((paycenter.status === 'connected' && paycenter.payment_ready !== true) || showQuickSetupForm === true) &&
            <>
              <div className={'p-grid'}>
                <div className={"p-col-12 p-lg-6"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="paycenter_email">{t('paycenter_email')}</label>
                    <span className="p-d-block fake-input">
                        {paycenter.paycenter_email}
                      </span>
                  </div>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="paycenter_password">{t('paycenter_password')}</label>
                    <span className="p-d-block fake-input">
                        ***
                    </span>
                  </div>
                </div>
              </div>
              <h3 className={'p-my-3'}>
                {(paycenter.status === 'connected' && paycenter.payment_ready !== true)
                  ? t('paycenter_quick_setup_missing_data')
                  : t('paycenter_quick_setup')}
              </h3>
              <div className={'p-grid'}>
                <div className={'p-col-12'}>
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="paycenter_quick_setup_selected_accepting_place">{t('paycenter_accepting_place_name')}</label>
                    <span className="p-inputgroup">
                      <Dropdown 
                        id="paycenter_quick_setup_selected_accepting_place"
                        options={acceptingPlaces}
                        optionLabel="label"
                        optionValue="id"
                        value={quickSetup.selected_accepting_place_id}
                        placeholder={t('paycenter_accepting_place_name')}
                        emptyMessage={t('empty_message')}
                        disabled={acceptingPlacesLoading}
                        onChange={(e) => {
                          setQuickSetup({
                            ...quickSetup,
                            selected_accepting_place_id: e.value,
                            accepting_place_name: ''
                          });
                        }}
                      />
                      <Button type="button"
                              icon={"pi pi-times"}
                              disabled={acceptingPlacesLoading || !quickSetup.selected_accepting_place_id}
                              onClick={() => {
                                setQuickSetup({
                                  ...quickSetup,
                                  selected_accepting_place_id: null,
                                  accepting_place_name: ''
                                });
                              }}
                              className="p-button-secondary close">
                                </Button>
                    </span>
                  </div>
                </div>
              </div>
              {isNewAcceptingPlaceMode &&
                <>
                  <div className={'p-grid'}>
                    <div className={'p-col-12 p-text-center'}>
                      <div
                        className="p-d-flex p-ai-center p-text-secondary"
                        style={{gap: '12px'}}
                      >
                        <span style={{height: '1px', background: '#ced4da', flex: 1}}/>
                        <span>{t('paycenter_or_separator')}</span>
                        <span style={{height: '1px', background: '#ced4da', flex: 1}}/>
                      </div>
                    </div>
                  </div>
                  <div className={'p-grid'}>
                    <div className={'p-col-12'}>
                      <div className="p-field p-fluid">
                        <label
                          htmlFor="paycenter_quick_setup_accepting_place_name">{t('paycenter_accepting_place_new_name')}</label>
                        <InputText
                          id="paycenter_quick_setup_accepting_place_name"
                          value={quickSetup.accepting_place_name}
                          onChange={(e) => {
                            setQuickSetup({
                              ...quickSetup,
                              selected_accepting_place_id: null,
                              accepting_place_name: e.target.value
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={'p-grid'}>
                    <div className={'p-col-12 p-lg-6'}>
                      <div className="p-field p-fluid">
                        <label htmlFor="paycenter_quick_setup_company_name">{t('company_name')}</label>
                        <InputText
                          id="paycenter_quick_setup_company_name"
                          value={quickSetup.company_name}
                          onChange={(e) => {
                            setQuickSetup({
                              ...quickSetup,
                              company_name: e.target.value
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'p-col-12 p-lg-6'}>
                      <div className="p-field p-fluid">
                        <label htmlFor="paycenter_quick_setup_tax_number">{t('tax_number')}</label>
                        <InputText
                          id="paycenter_quick_setup_tax_number"
                          value={quickSetup.tax_number}
                          onChange={(e) => {
                            setQuickSetup({
                              ...quickSetup,
                              tax_number: e.target.value
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'p-col-12 p-lg-2'}>
                      <div className="p-field p-fluid">
                        <label htmlFor="paycenter_quick_setup_zip_code">{t('zip_code')}</label>
                        <InputText
                          id="paycenter_quick_setup_zip_code"
                          value={quickSetup.zip_code}
                          onChange={(e) => {
                            setQuickSetup({
                              ...quickSetup,
                              zip_code: e.target.value
                            });
                            if (e.target.value.length >= 4) {
                              window.App.zipCode(e.target.value, (city) => {
                                setQuickSetup((prev) => ({
                                  ...prev,
                                  registered_office_city: city
                                }));
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className={'p-col-12 p-lg-3'}>
                      <div className="p-field p-fluid">
                        <label htmlFor="paycenter_quick_setup_registered_office_city">{t('registered_office_city')}</label>
                        <InputText
                          id="paycenter_quick_setup_registered_office_city"
                          value={quickSetup.registered_office_city}
                          onChange={(e) => {
                            setQuickSetup({
                              ...quickSetup,
                              registered_office_city: e.target.value
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'p-col-12 p-lg-7'}>
                      <div className="p-field p-fluid">
                        <label
                          htmlFor="paycenter_quick_setup_street_and_house_number">{t('street_and_house_number')}</label>
                        <InputText
                          id="paycenter_quick_setup_street_and_house_number"
                          value={quickSetup.street_and_house_number}
                          onChange={(e) => {
                            setQuickSetup({
                              ...quickSetup,
                              street_and_house_number: e.target.value
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className={'p-col-12 p-lg-4'}>
                      <div className="p-field p-fluid">
                        <label htmlFor="paycenter_quick_setup_vat_payment"
                               className={'p-mb-2 p-d-block'}>{t('paycenter_vat_payment')}</label>
                        <InputSwitch
                          className={"p-mt-2"}
                          id="paycenter_quick_setup_vat_payment"
                          checked={quickSetup.vat_payment}
                          onChange={(e) => {
                            setQuickSetup({
                              ...quickSetup,
                              vat_payment: e.value
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>}
              <div className={'p-grid'}>
                {showQuickSetupForm === true &&
                  <div className={'p-col-12'}>
                    <Button
                      type="button"
                      label={t('paycenter_connect')}
                      icon={'pi pi-link'}
                      loading={loading}
                      onClick={() => {
                        setShowQuickSetupForm(false);
                        setTimeout(() => {
                          document.getElementById('paycenter_email')?.focus();
                        }, 0);
                      }}
                      className="p-button-info p-mr-2 p-mb-2"
                    />
                  </div>
                }
                {showQuickSetupForm !== true && !(paycenter.status === 'connected' && paycenter.payment_ready !== true) &&
                  <div className={'p-col-12 p-text-right'}>
                    <Button
                      type="button"
                      label={t('paycenter_complete_setup')}
                      icon={'pi pi-save'}
                      className="p-button-success"
                      loading={loading}
                      onClick={() => {
                        if (!isQuickSetupValid()) {
                          window.App.toastShow('warn', t('warning'), t('paycenter_quick_setup_required_fields'));
                          const invalidFieldId = getQuickSetupFirstInvalidFieldId();
                          if (invalidFieldId) {
                            document.getElementById(invalidFieldId)?.focus();
                          }
                          return;
                        }
                        setLoading(true);
                        axios.post(
                          process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'integration/paycenter/quick-setup',
                          getQuickSetupPayload(),
                          {
                            params: {},
                            headers: {
                              Authorization: 'Bearer ' + Cookies.get('userToken'),
                              'Sys-name': Cookies.get('instanceId'),
                              'Preferred-locale': Cookies.get('language')
                            }
                          }
                        )
                          .then((response) => {
                            setQuickSetupDone(true);
                            setShowQuickSetupForm(false);
                            setLoading(false);
                            window.App.toastShow('success', t('success'), response.data.message || t('paycenter_quick_setup_success'));
                            window.App.setState({
                              rerenderPaycenterForm: Math.random()
                            });
                          })
                          .catch((error) => {
                            setLoading(false);
                            window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
                          });
                      }}
                    />
                  </div>
                }
              </div>
            </>}
        </Panel>
      </BlockUI>
    </>
  );
};

export default withTranslation('common')(PaycenterFormComponent);
